export default "__VITE_ASSET__30MMEdfe__"